import {
	addLocalePrefix,
	isI18nLocaleRoute,
	parseLocaleFromPath,
	stripLocalePrefix,
} from "~/utils/i18n-locale-routes";
import { getRuntimeLocale } from "~/i18n/index";

export default defineNuxtPlugin(() => {
	const router = useRouter();

	router.beforeEach(to => {
		if (!isI18nLocaleRoute(to.path)) return true;

		// Keep explicit URL prefixes authoritative.
		if (parseLocaleFromPath(to.path)) return true;

		const stripped = stripLocalePrefix(to.path);
		const runtimeLocale = getRuntimeLocale();

		if (runtimeLocale !== "en") return true;

		const localizedPath = addLocalePrefix(stripped, "en");
		if (to.path === localizedPath) return true;

		return navigateTo({
			path: localizedPath,
			query: to.query,
			hash: to.hash,
		});
	});
});
